"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PinInput = require("./PinInput");
Object.keys(_PinInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PinInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PinInput[key];
    }
  });
});